import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Box, HStack, VStack, Spacer, Text, Image } from '@chakra-ui/react';
import { isTimeDue } from 'utils/dynDateUtils';
import { getImageUrl } from 'utils/ImageImporter';

function StoryCard({ storyId, title, genre, status, url, dueDate }) {
  const navigate = useNavigate();

  function handleCardClick() {
    console.log('card is clicked, the storyId: ', storyId);
    navigate(`/impromptu-story/${storyId}`);
  }

  function capitalizeType(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1) + ' Story';
  }

  return (
    <Box
      // key={key}
      borderRadius="md"
      overflow="hidden"
      boxShadow="md"
      borderWidth="1px"
      maxW={{ base: 'none', md: 'sm' }}
      w="full"
      cursor="pointer"
      onClick={handleCardClick}
    >
      {/* Upper Part: Image */}
      <Box position="relative" w="100%" pt="66%">
        {' '}
        {/* 3:2 Aspect Ratio */}
        <Image
          src={getImageUrl(url || genre)}
          alt={title}
          position="absolute"
          top="0"
          left="0"
          w="100%"
          h="100%"
          objectFit="cover"
          transition="0.3s ease-in-out"
          _hover={{
            transform: 'scale(1.05)',
          }}
        />
      </Box>

      {/* Bottom Part: Content */}
      <VStack align="start" p={4} spacing={1}>
        <Text
          fontWeight="bold"
          fontSize="sm"
          display="-webkit-box"
          overflow="hidden"
          sx={{
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
          }}
          lineHeight="1.2"
        >
          {title}
        </Text>
        {status == 'Done' ? (
          <Text fontSize="sm" color="gray.600">
            {capitalizeType(genre)}
          </Text>
        ) : (
          <HStack w="100%">
            <Text fontSize="sm" color="gray.600">
              {status}
            </Text>
            <Spacer />
            <Text
              fontSize="sm"
              color={isTimeDue(dueDate) ? 'red.500' : 'blue.500'}
            >
              Due: {new Date(dueDate).toLocaleDateString()}
            </Text>
          </HStack>
        )}
      </VStack>
    </Box>
  );
}

StoryCard.propTypes = {
  storyId: PropTypes.string.isRequired,
  genre: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  dueDate: PropTypes.string,
  url: PropTypes.string,
};

export default StoryCard;
